// extracted by mini-css-extract-plugin
export var activeDot = "_3l-c";
export var buttonContainer = "_3l-9";
export var channelButton = "_3l-a";
export var clickable = "_3l-d";
export var content = "_3l-0";
export var contentFull = "_3l-2";
export var contentThird = "_3l-1";
export var contentWrapper = "_3l-7";
export var description = "_3l-5";
export var heightShort = "_3l-f";
export var image = "_3l-3";
export var imageContainer = "_3l-4";
export var selectButton = "_3l-e";
export var spinnerContainer = "_3l-b";
export var titleContent = "_3l-8";
export var titleWrapper = "_3l-6";